import truncateText from '@/filters/truncate-text'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      impersonateContactId: 'auth/impersonateContactId',
      currentUser: 'auth/currentUser',
    }),
    firstName() {
      const fname = this.currentUser?.firstName || 'Unknown'
      const fnameCharLimit = this.isMobileViewPort ? 15 : 30
      return `${truncateText(fname.trim(), fnameCharLimit)}${
        this.isDebug ? ` (ID: ${this.impersonateContactId})` : ''
      }`
    },
  },
}
